import type { QueryKey, RefetchFn } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import type { TransportOrderEventList } from "@msuite/utils/types";
import { transportEventsTableColumns } from "../transport-events-table-config";

/** Props Interface */
interface TransportEventsTableProps {
	events: TransportOrderEventList | undefined;
	isLoading: boolean;
	queryKey: QueryKey | undefined;
	refetch: RefetchFn | undefined;
	persistenceKey: `${string}-table`;
	/** A single leg's history already knows its box and its round, so both columns are hidden. */
	withCarrier?: boolean;
}

/**
 * A chain of custody, in the order the server returned it — chronological for one leg, and grouped
 * by box then chronological for a whole round.
 */
export function TransportEventsTable({
	events,
	isLoading,
	queryKey,
	refetch,
	persistenceKey,
	withCarrier = true,
}: TransportEventsTableProps) {
	/** Render */
	return (
		<DataTable
			data={events}
			columns={transportEventsTableColumns}
			queryKey={queryKey}
			isLoading={isLoading}
			refetch={refetch}
			persistenceKey={persistenceKey}
			initialColumnVisibility={{ carrier: withCarrier, suborder: withCarrier }}
			menu={null}
		/>
	);
}
